/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { ItemProps } from './types';
import { generateID } from '../../base/helper';

/**
 * Column should be limited to 1-12.
 * @param col
 * @returns
 */
const getColumnClass = (col?: number) => {
  const cl = Math.floor(col ?? 0);
  return cl >= 1 && cl <= 12 ? `${cl}` : '';
};

const getLayoutClasses = (sm?: number, md?: number) => {
  return ` grid-col-sm-${getColumnClass(sm)} grid-col-md-${getColumnClass(md)}`;
};

/**
 * Item of Grid
 * @public
 */
const Item: React.FC<ItemProps> = (props) => {
  const { id = generateID(), children, sm, md } = props;
  return (
    <div
      id={id}
      className={`clientos-ui-toolkit-grid-item ${getLayoutClasses(sm, md)}`}
    >
      {children}
    </div>
  );
};

export default memo(Item);
